import { _ } from '@swc/helpers/esm/_object_spread.js';
import { _ as _$1 } from '@swc/helpers/esm/_object_spread_props.js';
import { cx } from 'instantsearch-ui-components';
import { render, h } from 'preact';
import VoiceSearch from '../../components/VoiceSearch/VoiceSearch.js';
import connectVoiceSearch from '../../connectors/voice-search/connectVoiceSearch.js';
import { component } from '../../lib/suit.js';
import defaultTemplates from './defaultTemplates.js';
import { createDocumentationMessageGenerator } from '../../lib/utils/documentation.js';
import { getContainerNode } from '../../lib/utils/getContainerNode.js';

var withUsage = createDocumentationMessageGenerator({
    name: 'voice-search'
});
var suit = component('VoiceSearch');
var renderer = function renderer(param) {
    var containerNode = param.containerNode, cssClasses = param.cssClasses, templates = param.templates;
    return function(param) {
        var isBrowserSupported = param.isBrowserSupported, isListening = param.isListening, toggleListening = param.toggleListening, voiceListeningState = param.voiceListeningState;
        render(/*#__PURE__*/ h(VoiceSearch, {
            cssClasses: cssClasses,
            templates: templates,
            isBrowserSupported: isBrowserSupported,
            isListening: isListening,
            toggleListening: toggleListening,
            voiceListeningState: voiceListeningState
        }), containerNode);
    };
};
var voiceSearch = function voiceSearch(widgetParams) {
    var _ref = widgetParams || {}, container = _ref.container, tmp = _ref.cssClasses, userCssClasses = tmp === void 0 ? {} : tmp, tmp1 = _ref.templates, userTemplates = tmp1 === void 0 ? {} : tmp1, _ref_searchAsYouSpeak = _ref.searchAsYouSpeak, searchAsYouSpeak = _ref_searchAsYouSpeak === void 0 ? false : _ref_searchAsYouSpeak, language = _ref.language, additionalQueryParameters = _ref.additionalQueryParameters, createVoiceSearchHelper = _ref.createVoiceSearchHelper;
    if (!container) {
        throw new Error(withUsage('The `container` option is required.'));
    }
    var containerNode = getContainerNode(container);
    var cssClasses = {
        root: cx(suit(), userCssClasses.root),
        button: cx(suit({
            descendantName: 'button'
        }), userCssClasses.button),
        status: cx(suit({
            descendantName: 'status'
        }), userCssClasses.status)
    };
    var templates = _({}, defaultTemplates, userTemplates);
    var specializedRenderer = renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates
    });
    var makeWidget = connectVoiceSearch(specializedRenderer, function() {
        return render(null, containerNode);
    });
    return _$1(_({}, makeWidget({
        container: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        searchAsYouSpeak: searchAsYouSpeak,
        language: language,
        additionalQueryParameters: additionalQueryParameters,
        createVoiceSearchHelper: createVoiceSearchHelper
    })), {
        $$widgetType: 'ais.voiceSearch'
    });
};

export { voiceSearch as default };
